namespace app.quickPanel {
    'use strict';
        
    export class QuickPanelController {
        
        /** @ngInject **/
        constructor() { }
    }

    angular
        .module('app.quick-panel')
        .controller('app.QuickPanelController', QuickPanelController);
}